<template>
  <div data-app class="main-container">
    <v-sheet elevation="4" width="100%" min-height="300" class="pa-3">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex align-center gap-3">
                        <v-btn @click="is_new_order = !is_new_order;">New order</v-btn>
                        <v-btn @click="is_new_filter = !is_new_filter;">Statistics</v-btn>
                        <v-sheet elevation="2" rounded class="inv-topbar__counter" :class="{ 'inv-topbar__counter--paused': documentHidden }">
                          <span class="inv-topbar__counter-dot" v-if="!documentHidden"></span>
                          <span class="inv-topbar__counter-label">Next refresh</span>
                          <span class="inv-topbar__counter-num">{{ pollCountdownText }}</span>
                        </v-sheet>
                    </div>
                    <v-slide-y-transition>
                        <OrderFilters @show-orders="showOrders" v-if="is_new_filter" :has-order-filter="hasOrderFilter"
                        :order-status="filters.is_marked"></OrderFilters>
                    </v-slide-y-transition>
                    <v-slide-x-transition>
                        <v-sheet elevation="4" width="100%" min-height="100" class="pa-3 mt-2" v-if="is_new_order">
                            <v-tabs v-model="activeTab">
                                <v-tab key="manual">
                                    Manual
                                </v-tab>
                                <v-tab key="sync">
                                    Sync from SO
                                </v-tab>
                            
                                <v-tabs-items v-model="activeTab">
                                    <v-tab-item key="manual">
                                        <div class="pa-4">
                                            <ManualOrderForm ref="manualReset" :editData="editData" @saveAndFetch="saveAndFetch" @cancelEdit="cancelEdit"></ManualOrderForm>
                                        </div>
                                    </v-tab-item>
                                
                                    <v-tab-item key="sync">
                                        <div class="pa-4">
                                            <SyncFromSO ref="syncReset" @order-synced="addOrderToList"></SyncFromSO>
                                        </div>
                                    </v-tab-item>
                                </v-tabs-items>
                            </v-tabs>
                        </v-sheet>
                    </v-slide-x-transition>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="align-center">
                <v-col cols="12" lg="3" md="6">
                    <div class="d-flex align-center gap-3">
                        <v-btn @click="markOrderDone()" :disabled="rem_checkbox.length === 0">Mark as done</v-btn>
                        <v-select
                            v-model="filters.is_marked"
                            label="Status"
                            :items="['All','Live','Closed']"
                            hide-details
                            class="mt-0 pt-0"
                        ></v-select>
                    </div>
                </v-col>
                <v-col cols="6" lg="2" md="3">
                    <div class="d-flex align-center gap-3">
                        <v-select
                            v-model="filters.sales_from"
                            label="Sales From"
                            :items="['All','Livestock','Ironmongery']"
                            hide-details
                            class="mt-0 pt-0"
                        ></v-select>
                    </div>
                </v-col>
                <v-col cols="12" lg="3" md="6">
                    <v-text-field
                        v-model="filters.search" label="Search">
                    </v-text-field>
                </v-col>
                <v-col cols="12" lg="1" md="3" v-if="hasOrderFilter">
                    <v-btn @click="showOrders([])" color="error">Clear Order Filter</v-btn>
                </v-col>
                <v-col cols="12" lg="1" md="3">
                    <v-chip
                      color="red"
                      text-color="white"
                      @click="refreshOrdersFromRemoteChange()"
                      v-if="this.hasRemoteChanges"
                    >
                      <v-icon
                        left
                      >
                        mdi-alert-circle
                      </v-icon>
                      Refresh
                    </v-chip>
                    <v-chip
                      color="green"
                      text-color="white"
                      @click="startPolling()"
                      v-if="!this.hasRemoteChanges"
                    >
                      <v-icon
                        left
                      >
                        mdi-fire
                      </v-icon>
                      Hot Reload
                    </v-chip>
                </v-col>
                <v-col cols="12" lg="2" md="3" v-if="sortMode === 'manual'">
                    <v-chip
                      v-if="sortMode === 'manual'"
                      class="ml-3"
                      outlined
                      @click="sortMode = 'auto'"
                    >
                      Manual order (click to reset)
                    </v-chip>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <OrdersTable
                      v-if="$vuetify.breakpoint.mdAndUp"
                      :headers="headers"
                      :items="filteredLocalOrders"
                      :loading="loading"
                      :selected-ids.sync="rem_checkbox"
                      :color-order="colorOrder"
                      :palette="palette"
                      :on-save-text="saveItemsText"
                      @reorder-page="syncPageOrder"
                      @start-edit="startEdit"
                      @color-change="setRowColor"
                    />

                    <MobileOrders
                      v-else
                      :items="filteredLocalOrders"
                      :loading="loading"
                      :selected-ids.sync="rem_checkbox"
                      :color-order="colorOrder"
                      :palette="palette"
                      @edit="startEdit"
                      @color-change="setRowColor"
                    ></MobileOrders>
                </v-col>
            </v-row>
        </v-container>
    </v-sheet>
  </div>
</template>

<script>
//import { mapGetters, mapActions } from "vuex";
import ApiService from "@/core/services/api.service";

import Swal from "sweetalert2";
import ManualOrderForm from "./components/ManualOrderForm.vue";
import SyncFromSO from "./components/SyncFromSO.vue";
import MobileOrders from "./components/MobileOrders.vue";
import OrderFilters from "./components/OrderFilters.vue";
import OrdersTable from "./components/OrdersTable.vue";


export const ENDPOINT = "sales/Orders/";

export default {
  name: "Orders",
  components: { ManualOrderForm, SyncFromSO, MobileOrders, OrderFilters, OrdersTable},
  data() {
    return {
      loading: true,
      expanded: [],
      singleExpand: false,
      showAll: false,
      search: "",
      items:[],
      localOrders:[],
      hasOrderFilter: false,
      headers: [
        {text:'', sortable:false, value:'drag', width: 48},
        {text:'Basic Information', align: 'center', sortable:true, value:'so_id'},
        {text:'Shipping address', align: 'center', sortable:true, value:'shipping_address.shipping.postal_code'},
        {text:'Item(s)', align: 'center', sortable:true, value:'salesOrder.so_number'},
        {text:'Order Date', align: 'center', sortable:true, value:'order_date'},
        {text:'Administrator', align: 'center', sortable:true, value:'user_id'},
        {text:'Comment', align: 'center', sortable:true, value:'comment'},
        {text:'Actions', align: 'center', sortable:true, value:'actions'},
      ],
      rem_checkbox: [],
      is_new_order: false,
      is_new_filter: false,
      activeTab: 1,
      filters: {
       is_marked: 'Live',
       sales_from: 'All',
       search: "",
       //status: null,
      },
      editData: {
        id: null,
        data: null,
      },

        colorOrder: [
          'amber','yellow','lime','green','emerald',
          'teal','cyan','sky','blue','indigo','violet','purple','pink','orange'
        ],

        palette: {
          red: '#EF4444',
          orange: '#F97316',
          amber: '#F59E0B',
          yellow: '#EAB308',
          lime: '#84CC16',
          green: '#22C55E',
          emerald: '#10B981',
          teal: '#14B8A6',
          cyan: '#06B6D4',
          sky: '#0EA5E9',
          blue: '#3B82F6',
          indigo: '#6366F1',
          violet: '#8B5CF6',
          purple: '#A855F7',
          pink: '#EC4899',
          default: '#ffffff',
        },
        sortMode: 'auto',
        orderTimer: null,
        lastSeenChangeAt: new Date().toISOString(),
        hasRemoteChanges: false,
        remoteLastChangeAt: null,

        pollTimer: null,
        tabVisible: !document.hidden,
        countdownTimer: null,
        nextPollAt: null,
        pollEveryMs: 600000,
        pollRemainingMs: 0,
        isPolling: false,
    }
  },

  computed: {
    //...mapGetters([]),
    filteredLocalOrders(){
        let rows = [...this.localOrders];

        const orderMap = new Map(this.localOrders.map((o, idx) => [o.id, idx]));
        const orderOf = (o) => orderMap.get(o.id) ?? 999999;

        const zipOf = (o) => {
            const z = o?.shipping_address?.shipping?.postal_code;

            if (z === null || z === undefined || String(z).trim() === '') return Infinity;

            const n = Number(z);
            if (!Number.isFinite(n)) return Infinity;

            return n;
        };

        if (this.filters.is_marked === 'All') {
          rows = rows.filter(o => o);
        } else if (this.filters.is_marked === 'Live') {
          rows = rows.filter(o => o.marked_at === null);
        } else if (this.filters.is_marked === 'Closed') {
          rows = rows.filter(o => o.marked_at !== null);
        }

        if (this.filters.sales_from === 'All') {
          rows = rows.filter(o => o);
        } else if (this.filters.sales_from === 'Livestock') {
            const livestock = [2,5,9];
            rows = rows.filter(o => {
                if(!o.meta) return;
                if(!o.meta.sales_point_id) return;

                return livestock.includes(Number(o?.meta?.sales_point_id));
            });
        } else if (this.filters.sales_from === 'Ironmongery') {
            rows = rows.filter(o => {
                if(!o.meta) return;
                if(!o.meta.sales_point_id) return;

                return o?.meta?.sales_point_id === 7;
            });
        }

        const q = (this.filters.search || "").trim().toLowerCase();
        if (q) {
          rows = rows.filter(o =>
            String(o.id).includes(q) ||
            (o.company_name || "").toLowerCase().includes(q) ||
            (o.customer_name || "").toLowerCase().includes(q) ||
            (String(new Date(o.order_date).toLocaleString()) || "").includes(q) ||
            (o.user.christian_name1 || "").toLowerCase().includes(q) ||
            (o.user.christian_name2 || "").toLowerCase().includes(q) ||
            (o.user.surname || "").toLowerCase().includes(q) ||
            (o.tax_number || "").toLowerCase().includes(q) ||
            (o?.shipping_address?.shipping.address || "").toLowerCase().includes(q) ||
            (o?.shipping_address?.shipping.city || "").toLowerCase().includes(q) ||
            (String(o?.shipping_address?.shipping.postal_code) || "").toLowerCase().includes(q) ||
            (o.billing_address.billing.address || "").toLowerCase().includes(q) ||
            (o.billing_address.billing.city || "").toLowerCase().includes(q) ||
            (String(o.billing_address.billing.postal_code) || "").toLowerCase().includes(q) ||
            (o.items_text || "").toLowerCase().includes(q) ||
            (o.customer_phone || "").toLowerCase().includes(q) ||
            (o.customer_name || "").toLowerCase().includes(q) ||
            (o.customer_email || "").toLowerCase().includes(q) ||
            (o.comment || "").toLowerCase().includes(q) ||
            (o.salesOrder && o.salesOrder.so_number || "").toLowerCase().includes(q) ||
            (o.sales_order && o.sales_order.so_number || "").toLowerCase().includes(q)
          );
        }

        if (this.sortMode === 'manual') {
            return rows;
        }

        /*if (this.filters.status) {
          rows = rows.filter(o => o.status === this.filters.status);
        }*/

        const hasColor = rows.some(o => (o?.meta?.color ?? null) !== null);

        if(!hasColor){
            return rows.sort((a,b) => zipOf(a) - zipOf(b) || (orderOf(a) - orderOf(b)));
        };

        const colorOrder = ['red','amber','yellow','lime',
        'green','emerald','teal','cyan','sky','blue','indigo','violet','purple','pink','orange'];

        const getColor = (o) => {
            if (this.isDueWithinDays(o, 5)) return 'red';

            const c = o?.meta?.color ?? 'default';
            return c;
        };

        const rank = (c) => {
            if (!c) return 999;
            const i = colorOrder.indexOf(c);

            return i === -1 ? 998 : i;
        }

        const buckets = new Map();
        for(const r of rows){
            const c = getColor(r);
            if(!buckets.has(c)) buckets.set(c, []);

            buckets.get(c).push(r);
        }

        for (const [c, arr] of buckets.entries()) {
            void c;
            arr.sort((a, b) => zipOf(a) - zipOf(b) || (orderOf(a) - orderOf(b)));
        }

        const keys = [...buckets.keys()].sort((a,b) => rank(a) - rank(b));

        return keys.flatMap(k => buckets.get(k));
    },
    pollCountdownText() {
      if (!this.tabVisible) return 'paused (background)';
      if (this.is_new_order) return 'paused (new order)';
      if (this.is_new_filter) return 'paused (statistics)';
      if (!this.nextPollAt) return '—';

      const totalSec = Math.ceil(this.pollRemainingMs / 1000);
      const m = String(Math.floor(totalSec / 60)).padStart(2, '0');
      const s = String(totalSec % 60).padStart(2, '0');
      return `${m}:${s}`;
    },
  },

  watch: {
    activeTab:{
        handler(val) {
            if(val){
                this.$refs.manualReset?.resetForm();
                this.$refs.syncReset?.resetForm();
            }
        }
    },
    'is_new_filter':{
      handler(val){
        if(val === true){
          this.stopPolling();
          this.scheduleNextPoll();
        }else{
          this.startPolling();
        }
      }
    },
    'is_new_order':{
      handler(val){
        if(val === true){
          this.stopPolling();
          this.scheduleNextPoll();
        }else{
          this.startPolling();
        }
      }
    }
  },

  methods: {
    //...mapActions([]),
    async saveItemsText(orderId, text) {
      try {
        const resp = await ApiService.update(ENDPOINT + "update", orderId, {
          items_text: text,
        });

        //console.log("resp", resp.data?.order);
      
        const updated = resp.data?.order;
        if (!updated) return null;
      
        const idx = this.localOrders.findIndex((o) => o.id === updated.id);
        if (idx !== -1) {
          this.$set(this.localOrders, idx, { ...this.localOrders[idx], ...updated });
        }
      
        return updated;
      } catch (e) {
        console.log("STATUS:", e?.response?.status);
        console.log("DATA:", e?.response?.data);
        console.log("ERR:", e);
        throw e;
      }
    },
  
    async setRowColor(item, key) {
      if (!item.meta) this.$set(item, "meta", {});
      this.$set(item.meta, "color", key || "default");
    
      try {
        return ApiService.update(ENDPOINT + "update", item.id, { meta: item.meta });
      } catch (e) {
        console.log("STATUS:", e?.response?.status);
        console.log("DATA:", e?.response?.data);
        console.log("ERR:", e);
      }
    },
    saveAndFetch(){
        this.is_new_order = false;
        this.activeTab = 1;
        this.fetchOrders();
    },
    async fetchOrders(){
        this.loading = true;
        try{
            await ApiService.get(ENDPOINT + 'orders')
                .then((data) => {
                    this.items = [...data.data];
                    this.localOrders = [...this.items];
                    this.sortMode = 'auto';
                    //console.log(data);
                });
        }catch(e){
            console.log("STATUS:", e?.response?.status);
            console.log("DATA:", e?.response?.data);
            console.log("ERR:", e);
        }finally {
            this.loading = false;
        }
    },
    
    syncPageOrder(pageItems) {
      const ids = pageItems.map(x => x.id);
      const idSet = new Set(ids);

      const positions = [];
      this.localOrders.forEach((o, idx) => {
        if (idSet.has(o.id)) positions.push(idx);
      });

      positions.sort((a, b) => a - b);

      const next = [...this.localOrders];
      positions.forEach((pos, i) => {
        next[pos] = pageItems[i];
      });

      this.localOrders = next;
      this.sortMode = 'manual';
    },

    async markOrderDone(){
        if (this.rem_checkbox.length === 0) return;

        Swal.fire({
            title: "Are you sure you want to mark selected orders as completed?",
            showCancelButton: true,
            confirmButtonText: "Delete",
            confirmButtonColor: "#00ad00",
            cancelButtonColor: "#e33354",
        }).then((result) => {
            if (result.isConfirmed) {
                const selectedElements = document.querySelectorAll('.selected-item');

                selectedElements.forEach(el => {
                    el.classList.add('completed');
                    requestAnimationFrame(() => {
                        el.classList.add('active');
                    });
                });

                ApiService.post(ENDPOINT + 'markdone', {
                    order_ids: this.rem_checkbox
                })
                .then(() => {
                    Swal.fire("Success!", "", "success");

                    setTimeout(() => {
                        //this.loading = true;
                        
                        this.fetchOrders();

                        this.rem_checkbox = [];
                    }, 1500);                    
                })
                .catch((e) => {
                    console.log("ERROR:", e);
                    Swal.fire("Something went wrong!", "", "error");
                    document.querySelectorAll('.selected-item').forEach(el => {
                        el.classList.remove('completed', 'active');
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
            }
        });
    },
    addOrderToList(order){
        const exists = this.localOrders.some(o => o.so_id === order.so_id);
        if(exists) return;

        this.localOrders.push(order);
        this.is_new_order = false;

    },
    itemsToText(items){
        return items.map(i => this.itemToLine(i)).filter(Boolean).join('\n');
    },
    itemToLine(i) {
      const qty = i.qty ?? i.num_of_pcs ?? 0;
      const def_qty = i.default_qty ?? 0;
      const unit = i.unit ?? 'db';

      const ref = i.reference ?? '';
      const name =
        i.item_name ??
        '';
        
      const parts = [
        `${qty} db`,
        ref && `- ${ref}`,
        name && `- ${name}`,
        def_qty && `- ${def_qty} ${unit}`,
      ].filter(Boolean);
        
      return parts.join(' ');
    },
    startEdit(order){
        this.is_new_order = true;
        this.activeTab = 0;

        const existingText = (order.items_text ?? "").trim();
        const hasExistingText = existingText.length > 0;
        const hasItems = Array.isArray(order.items) && order.items.length > 0;

        this.editData = {
            id: order.id,
            data:{
                ...order,
                order_date: new Date(order.order_date).toISOString().slice(0, 10).replace("T", " "),
                items_text: hasExistingText ? existingText : (hasItems ? this.itemsToText(order.items) : ""),
            },
        };

        this.$nextTick(() => {
            const el = this.$refs.manualReset?.$el || this.$refs.manualReset;
            if (!el) return;

            this.$vuetify.goTo(el, { duration: 400, offset: 80, easing: "easeInOutCubic" });
        });
    },
    cancelEdit(){
        this.is_new_order = false;
        this.activeTab = 1;
        this.editData = {
            id: null,
            data: null,
        }
    },
    parseDeliveryDate(v) {
      if (!v) return null;

      const m = String(v).match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
      if (!m) return null;

      const y = parseInt(m[1], 10);
      const mo = parseInt(m[2], 10);
      const d = parseInt(m[3], 10);

      return new Date(y, mo - 1, d);
    },

    isDueWithinDays(item, days = 5) {
        const target = this.parseDeliveryDate(item?.meta?.delivery_date);
        if (!target) return false;

        const today = new Date();

        const utcDay = (d) => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
        const diffDays = Math.round((utcDay(target) - utcDay(today)) / 86400000);

        return Math.abs(diffDays) <= days;
    },
    showOrders(ids){
        if(ids.length === 0) {this.localOrders = [...this.items]; this.hasOrderFilter = false; return};
        
        const idSet = new Set((ids || []).map(Number));
        this.localOrders = this.items.filter(o => idSet.has(Number(o.id)));
        this.hasOrderFilter = true;
    },
    startPolling() {
      this.stopPolling();

      /*if (!document.hidden) {
        this.pollOnce();
        this.scheduleNextPoll();
      }*/


      this.scheduleNextPoll();

      this.pollTimer = setInterval(() => {
        if (!this.tabVisible) return;
        this.pollOnce();
        this.scheduleNextPoll();
      }, this.pollEveryMs);

      this.countdownTimer = setInterval(() => {
        if (!this.nextPollAt) return;

        if (!this.tabVisible) return;
        this.pollRemainingMs = Math.max(0, this.nextPollAt - Date.now());
      }, 1000);
      if (this.tabVisible) this.pollOnce();
    },

    stopPolling() {
      if (this.pollTimer) clearInterval(this.pollTimer);
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.pollTimer = null;
      this.countdownTimer = null;
    },

    onVisibilityChange() {
      this.tabVisible = !document.hidden;

      if (this.tabVisible) {
        if(this.is_new_order) return; 
        if(this.is_new_filter) return;

        this.startPolling();
        this.scheduleNextPoll();
      } else {
        this.stopPolling();
      }
    },

    async pollOnce() {
      if (this.isPolling) return;
      this.isPolling = true;
      if(this.is_new_order) return; 
      if(this.is_new_filter) return;

      try {
        const since = encodeURIComponent(this.lastSeenChangeAt);
        const resp = await ApiService.get(`${ENDPOINT}changes`, `?since=${since}`);
        const data = resp.data;

        console.log(data)

        if (data.has_changes) {
          this.hasRemoteChanges = true;
          this.remoteLastChangeAt = data.last_change_at;
        }

        this.fetchOrders();
      } catch (e) {
        console.log("STATUS:", e?.response?.status);
        console.log("DATA:", e?.response?.data);
        console.log("ERR:", e);
        this.stopPolling();
      } finally{
        this.isPolling = false;
      }
    },

    async refreshOrdersFromRemoteChange() {
        if(this.is_new_order){
            console.warn('close first');
            return;
        }

        this.pollOnce();
        this.hasRemoteChanges = false;
        this.lastSeenChangeAt = this.remoteLastChangeAt || new Date().toISOString();
    },
    scheduleNextPoll() {
      this.nextPollAt = Date.now() + this.pollEveryMs;
      this.pollRemainingMs = this.pollEveryMs;
    },
  },

  created() {
    document.addEventListener('visibilitychange', this.onVisibilityChange);

    this.startPolling();
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    this.stopPolling();
  },

  mounted() {
    this.fetchOrders();
    window.addEventListener('focus', this.pollOnce());
  },
};
</script>

<style>
.inv-topbar__counter{
  display: inline-flex;
  align-items: center;
  gap: 10px;

  padding: 8px 12px;
  border: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg2), var(--bg3));
  border-radius: 999px;

  font-family: 'IBM Plex Mono', monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
  color: var(--text);
  box-shadow: 0 1px 0 rgba(17, 24, 39, 0.05);
}

.inv-topbar__counter-label{
  color: var(--text-dim);
  font-weight: 600;
  white-space: nowrap;
}

.inv-topbar__counter-num{
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 52px;
  padding: 4px 10px;

  border-radius: 999px;
  border: 1px solid var(--border2);
  background: #fff;

  color: var(--accent2);
  font-weight: 800;
  font-size: 13px;
  letter-spacing: 0.12em;
}

.inv-topbar__counter-dot{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--success);
  box-shadow: 0 0 0 3px rgba(22, 163, 74, 0.12);
}

.inv-topbar__counter--paused{
  opacity: 0.75;
}

.inv-topbar__counter--paused .inv-topbar__counter-num{
  color: var(--text-dim);
}

@media (max-width: 768px) {
  .inv-topbar__counter{
    padding: 7px 10px;
    gap: 8px;
    font-size: 12px;
  }
  .inv-topbar__counter-num{
    min-width: 46px;
    padding: 3px 8px;
    font-size: 12px;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .container {
    max-width: 970px !important;
  }
}

@media (min-width: 1264px) and (max-width: 1903px) {
  .container {
    max-width: 1555px !important;
  }
}

@media (min-width: 1904px) {
  .container {
    max-width: 2245px !important;
  }
}
</style>